import React, { useRef } from "react";
import { CPButton, CustomisedTertiaryButton } from "../../../constants/common/StyledGlobalConstants";
import DatePicker from "react-datepicker";
import Select from "react-select";
import styled from "styled-components";
import { Wrapper } from "../../cases/ViewCases";
import moment from "moment";
import Scheduler from "../../../assets/icons/scheduler.png";
import { getDateFormat } from "../../../util/dateUtils";
import PropTypes from "prop-types";
import { DEVICE_BREAKPOINTS } from "../../../constants/appConstants";
import { getPendoIdPrefix } from "../../../util/cfstPendoUtils";

const { TABLET, DESKTOP } = DEVICE_BREAKPOINTS;

const DateFilterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin-left: ${(props) => (props.marginLeft ? props.marginLeft : "")};
  @media (max-width: 767px) {
    width: 100%;
  }

  & label {
    font-weight: bold;
    font-family: neue-haas-grotesk-text;
    color: #000000;
    font-size: 0.75rem;
  }
  & input {
    border-radius: 4px;
    border: 1px solid #d8dada;
    font-size: 0.875rem;
    margin-top: ${(props) => (props.marginTop ? props.marginTop : "0.5rem")};
    // margin-right: ${(props) => (props.marginRight ? props.marginRight : "1rem")};
    height: 2.75rem;
    width: 100%;
    padding: 12px 16px 12px 16px;
    font-family: neue-haas-grotesk-text;
    @media (max-width: 1199px) {
      width: ${(props) => (props.inputWidth ? props.inputWidth : "")};
    }
    @media (min-width: 1200px) {
      width: 100%;
    }
  }
`;

export const CustomDatePicker = styled(DatePicker)`
  margin-left: -5px;
  div {
    input {
      width: 280px !important;
      font-size: 14px;
    }
  }
  & span {
    border-radius: 4px !important;
    border-color: rgb(0, 0, 0);
  }
`;

const SchedulerStyle = styled.img`
  width: 12px;
  position: absolute;
  margin-left: 89%;
  margin-top: 39px;
  cursor: pointer;
  @media (max-width: 1100px) and (min-width: 899px) {
    margin-left: 85%;
  }
  @media (max-width: 900px) and (min-width: 481px) {
    margin-left: 81%;
  }
`;

const ServiceText = styled.p`
  font-family: "neue-haas-grotesk-text";
  font-size: 12px;
  font-weight: 700;
  line-height: 12px;
  text-align: left;
  margin-bottom: 24px;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;
`;
function TechnicianAppointmentFilter({
  dateFilter,
  appointmentFilter,
  isFilterClearEnabled,
  setDateFilter,
  setAppointmentFilter,
  clearDateNdStatusFilter,
  technicianAppointmentFilter,
  windowSize,
}) {
  const options = [
    { value: "All", label: "All" },
    { value: "Scheduled", label: "Scheduled" },
    { value: "Complete", label: "Complete" },
    { value: "Cancelled", label: "Cancelled" },
    { value: "Rescheduled", label: "Rescheduled" },
  ];

  const dateFieldRef = useRef(null);
  const handleDateFilterFrom = (value) => {
    setDateFilter(moment(value).format("MM/DD/YYYY"));
  };

  const focusDateField = () => {
    dateFieldRef.current.input.focus();
  };

  const getMaxWidth = () => {
    if (windowSize.width < DESKTOP) {
      if (windowSize.width < TABLET) {
        return "";
      } else return "218px";
    } else return "260px";
  };

  function getStatusOptionBackgroundColor(state) {
    if (state.isFocused) {
      return "#0000000D";
    }
    if (state.isSelected) {
      return "var(--background-secondary, #F6F6F6)";
    }
    return "transparent";
  }

  return (
    <Wrapper
      marginBottom="24px"
      marginTop={windowSize.width < DESKTOP ? "2rem" : "3rem"}
      width="100%"
      display={windowSize.width >= TABLET ? "flex" : ""}
      style={{ backgroundColor: "#F6F6F6", borderRadius: "12px", padding: windowSize.width < TABLET ? "16px" : "24px" }}
    >
      {windowSize.width < TABLET && <ServiceText>{"Service"}</ServiceText>}

      <DateFilterWrapper
        id={`${getPendoIdPrefix()}-appointment-date-filter`}
        style={{ width: windowSize.width >= TABLET ? "33%" : "100%", maxWidth: getMaxWidth() }}
        role="search"
        aria-label="Date Search"
      >
        <label htmlFor="date input">{"Appointment date"}</label>
        <CustomDatePicker
          ref={dateFieldRef}
          id={`${getPendoIdPrefix()}-appt-list-date-picker`}
          autoComplete="off"
          selected={dateFilter ? new Date(dateFilter) : null}
          closeOnScroll={true}
          peekNextMonth
          showMonthDropdown
          showYearDropdown
          onSelect={handleDateFilterFrom}
          dropdownMode="select"
          width="100% !important"
          paddingRight="16px"
          placeholderText={getDateFormat("840")}
          title={dateFilter || "Select appointment date:"}
        ></CustomDatePicker>
        <SchedulerStyle alt="Scheduler-icon" onClick={focusDateField} src={Scheduler} />
      </DateFilterWrapper>

      <DateFilterWrapper
        aria-label="Date Search"
        style={{
          width: windowSize.width >= TABLET ? "33%" : "100%",
          maxWidth: getMaxWidth(),
          marginLeft: windowSize.width < TABLET ? "0" : " 11px",
        }}
      >
        <label htmlFor="date input">{"Status"}</label>
        <div style={{ marginTop: "0.5rem", marginRight: windowSize.width >= TABLET ? "1rem" : "" }}>
          <Select
            value={options.find((option) => option.value === appointmentFilter)}
            onChange={(selectedOption) => setAppointmentFilter(selectedOption.value)}
            options={options}
            styles={{
              control: (base, state) => ({
                ...base,
                width: "100%",
                height: "2.75rem",
                border: state.isFocused ? "2px solid var(--feedback-information, #006FC1)" : "1px solid #d8dada",
                borderRadius: "4px",
                fontSize: "0.875rem",
                fontFamily: '"neue-haas-grotesk-text"',
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                backgroundColor: state.isFocused ? "var(--background-secondary, #F6F6F6)" : "#fff", //when focused
                flexWrap: "nowrap",
                boxShadow: "none",
              }),
              indicatorSeparator: () => ({
                display: "none",
              }),
              placeholder: (base) => ({
                ...base,
                fontSize: "0.875rem",
                fontFamily: '"neue-haas-grotesk-text"',
                color: "#000",
              }),
              menu: (base) => ({
                ...base,
                width: "100%",
                zIndex: 9999,
                backgroundColor: "#fff",
                border: "1px solid #d8dada",
                borderRadius: "4px",
                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
              }),
              option: (base, state) => ({
                ...base,
                paddingTop: "14px", // Top padding
                paddingRight: "16px", // Right padding
                paddingBottom: "14px", // Bottom padding
                paddingLeft: "16px", // Left padding
                gap: "10px", // Gap between options
                fontSize: "0.875rem",
                fontWeight: 400,
                fontFamily: '"neue-haas-grotesk-text"',
                color: "#000",
                backgroundColor: getStatusOptionBackgroundColor(state),
                cursor: "pointer",
                padding: "0.5rem",
                borderLeft: state.isSelected ? "4px solid #EE0000" : "4px solid transparent",
                "&:active": {
                  backgroundColor: "#0000001F",
                },
              }),
            }}
            placeholder="Select Status"
            isSearchable={false}
            id={`${getPendoIdPrefix()}-appointment-status-filter`}
            aria-label="Status"
          />
        </div>
      </DateFilterWrapper>

      <div
        style={{
          marginRight: windowSize.width >= TABLET ? "1rem" : "",
          marginTop: "0.5rem",
        }}
      >
        <CPButton
          id={`${getPendoIdPrefix()}-appt-list-apply`}
          boxButton={true}
          marginTop={"1rem"}
          height={"2rem"}
          buttonWidth={"fit-content"}
          marginLeft={"0rem"}
          secondary={"#fff"}
          size="large"
          style={{ width: windowSize.width >= TABLET ? "auto" : "100%" }}
          onClick={technicianAppointmentFilter}
        >
          {"APPLY"}
        </CPButton>
      </div>
      <div
        style={{
          marginTop: windowSize.width < TABLET ? "1rem" : "0.5rem",
          marginRight: windowSize.width >= TABLET ? "1rem" : "",
        }}
      >
        <CustomisedTertiaryButton
          id={`${getPendoIdPrefix()}-appt-list-clear`}
          boxButton={true}
          marginTop={"1rem"}
          height={"2rem"}
          buttonWidth={"fit-content"}
          marginLeft={"0rem"}
          secondary={true}
          size="large"
          onClick={clearDateNdStatusFilter}
          disabled={!isFilterClearEnabled}
          style={{ width: windowSize.width >= TABLET ? "auto" : "100%" }}
        >
          {"CLEAR"}
        </CustomisedTertiaryButton>
      </div>
    </Wrapper>
  );
}

TechnicianAppointmentFilter.propTypes = {
  dateFilter: PropTypes.string,
  appointmentFilter: PropTypes.string,
  isFilterClearEnabled: PropTypes.bool,
  setDateFilter: PropTypes.func,
  setAppointmentFilter: PropTypes.func,
  clearDateNdStatusFilter: PropTypes.func,
  technicianAppointmentFilter: PropTypes.func,
  windowSize: PropTypes.number,
};

export default TechnicianAppointmentFilter;
